import { Button, TextField, Typography, Drawer, IconButton, Divider } from '@mui/material'
import ArrowForwardFilled from '@mui/icons-material/ArrowForward'
import dayjs from 'dayjs'
import { catalogFilterColumnType } from './catalogTypes'
import './CatalogFilter.css'
import { DatePicker } from '@impres-development/assets/client'

type filterProps = {
  filters: { [key: string]: string }
  setFilter: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>
  clearFilters: () => void
  open: boolean
  onClose: () => void
  columns: catalogFilterColumnType[]
}

export default function CatalogFilters({ filters, setFilter, clearFilters, open, onClose, columns }: filterProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} className="catalog-filter-drawer">
      <div className="catalog-filter-drawer-header">
        <Typography variant="h6">Catalog Filters</Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close filters">
          <ArrowForwardFilled fontSize="small" />
        </IconButton>
      </div>

      <Divider />

      <div className="catalog-filter-drawer-content">
        <div>
          <div className="catalog-filter-drawer-section">
            {columns.map(column =>
              column.type === 'date' ? (
                <DatePicker
                  key={column.key}
                  label={column.label}
                  value={filters[column.key] ? dayjs(filters[column.key]).local() : null}
                  onChange={value => {
                    if (!value) {
                      setFilter({ ...filters, [column.key]: '' })
                      return
                    }
                    const localMidnight = dayjs(value.utc().format('YYYY-MM-DD')).startOf('day')
                    setFilter({ ...filters, [column.key]: localMidnight.toISOString() })
                  }}
                  size="small"
                />
              ) : (
                <TextField
                  key={column.key}
                  size="small"
                  label={column.label}
                  fullWidth
                  value={filters[column.key]}
                  onChange={e => setFilter({ ...filters, [column.key]: e.target.value })}
                />
              ),
            )}
          </div>
          <div className="catalog-filter-drawer-actions">
            <Button size="large" variant="outlined" onClick={clearFilters}>
              Reset
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
